import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import { fixtureLoader } from '@shared/libs/allLoader'
import navStyles from '@shared/components/commonNav/style.module.scss'
import { Col, Nav, Row } from 'react-bootstrap'
import NoData from '@shared/components/noData'
import LazyLoad from '@shared/components/lazyLoad'
import useStatus from '@shared-submodule/sm-hooks/useStatus'

const FixturesItems = dynamic(() => import('@shared/components/series/fixturesItems'), { loading: () => fixtureLoader() })
// const Ads = dynamic(() => import('@shared/components/ads'), { ssr: false })

const MatchDetailUpcoming = ({ data }) => {
  const [activeTab, setActiveTab] = useState('all')
  const [fixturesData, setFixturesData] = useState(data)
  useEffect(() => {
    if (activeTab !== 'all') {
      const filteredData = data.filter((item) => useStatus(item)?.sStatusStr === activeTab)
      setFixturesData(filteredData)
    } else {
      setFixturesData(data)
    }
  }, [activeTab])
  const TABS = [
    { label: 'All', value: 'all' },
    { label: 'Live', value: 'live' },
    { label: 'Upcoming', value: 'scheduled' },
    { label: 'Results', value: 'completed' }
  ]
  return (
    <>
    <Nav className={`${navStyles.commonNav} ${navStyles.pillsNav} ml-01 mb-2 mt-2 mt-sm-0 `} variant="pills">
    {
      TABS.map((tab, i) => {
        return (
          <Nav.Item key={i} className={`${navStyles.item}`}>
            <a className={`${activeTab === tab.value && navStyles.active} nav-link`} onClick={() => setActiveTab(tab?.value)}>
              <div className="d-flex justify-content-between align-items-center flex-grow-1">
                {tab?.label}
              </div>
            </a>
          </Nav.Item>
        )
      })
    }
  </Nav>
    <Row>
      {fixturesData?.length > 0 && fixturesData?.map((fixture, index) => {
        if (index < 2) {
          return (
            <Col xl={6} key={index} className='mb-4 content-visibility-auto'>
              {/* {index === 5 && (
                <Ads
                  id="div-ad-gpt-138639789-1660147282-2"
                  adIdDesktop="oneturf2022_Desktop_LiveScore_MID_728x90"
                  adIdMobile="oneturf2022_Mobile_LiveScore_MID_300x250"
                  dimensionDesktop={[728, 90]}
                  dimensionMobile={[300, 250]}
                  mobile
                  className={'text-center mb-3'}
                />
              )} */}
              {/* {index === 10 && (
                <Ads
                  id="div-ad-gpt-138639789-1660147282-3"
                  adIdDesktop="oneturf2022_Desktop_LiveScore_MID2_728x90"
                  adIdMobile="oneturf2022_Mobile_LiveScore_MID2_300x250"
                  dimensionDesktop={[728, 90]}
                  dimensionMobile={[300, 250]}
                  mobile
                  className={'text-center mb-3'}
                />
              )} */}
              <FixturesItems key={fixture._id} fixture={fixture} />
            </Col>
          )
        } else {
          return (
            <LazyLoad key={index}>
              <Col xl={6} key={index} className='mb-4'>
                <FixturesItems key={fixture._id} fixture={fixture} />
              </Col>
            </LazyLoad>
          )
        }
      })}
      {fixturesData?.length === 0 && <NoData />}
    </Row>
    </>
  )
}

MatchDetailUpcoming.propTypes = {
  data: PropTypes.array
}

export default MatchDetailUpcoming
